import OfferTilePricing from 'components/OfferList/OfferListTiles/Support/OfferTilePricing'
import { CruiseOfferView } from 'hooks/Cruise/useCruiseOfferView'
import useCruisePriceByNight from 'hooks/useCruisePriceByNight'
import { isCruiseOffer } from 'lib/offer/offerTypes'
import React from 'react'
import CruiseSearchTilePricing from './CruiseSearchTilePricing'
import CruiseSearchTilePricingInfo from './CruiseSearchTilePricingInfo'
import useCruiseSelectedCabinType from 'hooks/useCruiseSelectedCabinType'
import { getCheapestCruiseFlashOfferByCabin } from 'lib/cruises/getCheapestCruiseFlashOfferByCabin'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyExperiments } from 'constants/optimizely'
import { getOptimizelyEnabledDecision } from 'lib/optimizely/optimizelyUtils'

interface Props {
  view: CruiseOfferView
}

function CruiseSearchTilePriceStack({ view }: Props) {
  const isPricePerNight = useCruisePriceByNight()
  const hasMoreThanOneAvailableCabinCategoriesPriceVariations = view.availableCabinCategoriesPriceVariations && view.availableCabinCategoriesPriceVariations.size > 1
  const selectedCabinType = useCruiseSelectedCabinType(view.cruiseType)

  // TODO: Remove this once the A/B test is complete https://aussiecommerce.atlassian.net/browse/CRUZ-3360
  const cruiseSearchTileRedesignEnabled = getOptimizelyEnabledDecision(useOptimizelyExperiment(OptimizelyExperiments.cruiseSearchTileRedesign))

  if (!isCruiseOffer(view.offer)) {
    const cheapestPackage = getCheapestCruiseFlashOfferByCabin({ offer: view.offer, cabinType: selectedCabinType || '' })
    return <OfferTilePricing
      offer={view.offer}
      isPricePerNight={isPricePerNight}
      pkg={cheapestPackage || view.offer.lowestPricePackage}
    />
  }

  // When cruiseSearchTileRedesignEnabled is enabled, always show single price (lowest price across all cabins)
  if (hasMoreThanOneAvailableCabinCategoriesPriceVariations && !selectedCabinType && !cruiseSearchTileRedesignEnabled) {
    return <CruiseSearchTilePricingInfo view={view} />
  }

  return <CruiseSearchTilePricing view={view} />
}

export default CruiseSearchTilePriceStack
